import { useApi } from '../../../core/api/api.context';
import { useInfiniteQuery } from 'react-query';
import { QueryKeys } from '../../../core/queries/query-keys.constants';
import { KnownSortOrder } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Delivery } from '../../deliveries/models/delivery.model';

export type UseQueryListDeliveriesRequiringAttentionParams = {
  deliveriesRequiringAttentionState: string;
  sortBy: string;
  sortOrder: KnownSortOrder;
};

export function useInfiniteQueryDeliveriesRequiringAttentionList(
  projectID: string | undefined,
  page: number,
  params: Partial<UseQueryListDeliveriesRequiringAttentionParams>
) {
  const api = useApi();

  return useInfiniteQuery(
    [QueryKeys.DELIVERIES, projectID, page, params],
    async ({ pageParam = 1 }) => {
      if (projectID === undefined) {
        return {
          items: [],
          totalRecords: 0,
          perPageRecords: 25,
          totalPages: 1,
          pageNo: 1
        };
      }
      const result = await api.reportsController.deliveriesRequiringAttention(
        (params.deliveriesRequiringAttentionState || '').split(','),
        {
          sortBy: params.sortBy,
          sortOrder: params.sortOrder,
          projectID,
          includeNotes: true,
          includeChildProjects: true,
          includeNotifications: true,
          pageNo: pageParam,
          perPageRecords: 25
        }
      );

      return { ...result, items: (result.items || []).map((d) => new Delivery(d)) };
    },
    {
      enabled: !!projectID,
      getNextPageParam(lastPage) {
        if (lastPage.pageNo < lastPage.totalPages) {
          return lastPage.pageNo + 1;
        } else {
          return undefined;
        }
      }
    }
  );
}
